import { render } from "./LinkWrapper.vue?vue&type=template&id=2c34941e"
import script from "./LinkWrapper.vue?vue&type=script&lang=js"
export * from "./LinkWrapper.vue?vue&type=script&lang=js"

import "./LinkWrapper.vue?vue&type=style&index=0&id=2c34941e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__